/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ICoreContext } from '@msdyn365-commerce/core-internal';
import { ICartState } from '@msdyn365-commerce/global-state';
import { CartLine, SalesLine } from '@msdyn365-commerce/retail-proxy';
import { IPriceEditorResources, PriceEditor } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

/**
 * Resources for the cart line price editor.
 */
export interface ICartLinePriceEditorResources extends IPriceEditorResources { }

/**
 * The props required to render the component.
 */
export interface ICartLinePriceEditorProps {
    className: string;
    context: ICoreContext;

    resources: ICartLinePriceEditorResources;

    cartLine: CartLine | SalesLine;
    cartState: ICartState;
}

/**
 * The props required to render the component.
 */
export interface ICartLinePriceEditorState {
    currentValue: number;
}

/**
 * Quantity Component - This component is used to allow input of quantity between a
 * range of values.
 */
export class CartLinePriceEditor extends React.PureComponent<ICartLinePriceEditorProps, ICartLinePriceEditorState> {
    public constructor(props: ICartLinePriceEditorProps) {
        super(props);
    }

    public render(): JSX.Element {
        const minimumPrice = 0.01;

        return (
            <PriceEditor
                className={this.props.className}
                resources={this.props.resources}
                defaultAmount={this.props.cartLine.Price!}
                maximumValue={this.props.cartLine.InvoiceAmount}
                minimumValue={minimumPrice}
                handleChange={this._handleChange}
            />
        );
    }

    /**
     * Handles updates of the input and updates the cart line amount.
     * @param newValue - New entered price for the cart line.
     */
    private readonly _handleChange = async (newValue: number) => {
        await this.props.cartState.setInvoiceLinePrice({ cartLineId: this.props.cartLine.LineId ?? null, price: newValue });
    };
}
